<template>
  <Dialog
    width="560px"
    height="unset"
    titleAlign="left"
    :title="null"
    :subTitle="null"
    :visible="visible"
    hideCloseBtn
    @close="closeDialog"
    mobileRenderType="drawerDialog"
    customClass="vip-release-dialog"
  >
    <div class="result-wrapper">
      <TipModal
        v-if="visible"
        :title="tipModalData.title"
        :content="feedListStore.release.failReason"
        :confirmText="tipModalData.confirmText"
        :cancelText="tipModalData.cancelText"
        :onConfirm="feedListStore.release.reReleaseCallback"
        :onCancel="closeDialog"
      />
    </div>
  </Dialog>
</template>

<script setup>
import TipModal from "./components/tipModal.vue";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore";

const userDataStore = useUserDataStore();
const feedListStore = useFeedListStore();

const tipModalData = reactive({
  title: "Review not approved",
  confirmText: "Re-release",
  cancelText: "Cancel",
  content: "Reason：Here is the content，here is the content, here is the content",
  onConfirm: () => {},
  onCancel: () => {},
});

const closeDialog = () => {
  feedListStore.closeReleaseFailDialog();
};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: '',
  }
});
</script>
<style lang="scss" scoped>
:deep(.dialog-box) {
  padding: 0;
}
.result-wrapper {

  .close-icon {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .res-title {
    margin-top: 24px;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    line-height: 44px;
  }
  .res-desc {
    margin-top: 16px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    line-height: 24px;
  }
  .res-song-card {
    margin-top: 28px;
    background: #000000;
    border-radius: 20px;
  }
  .res-learn-more {
    text-align: end;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    text-align: right;
    letter-spacing: 0em;
    text-decoration: underline;
    color: #00000040;
    margin-top: 12px;
  }
  :deep(.detail) {
    .title-box {
      margin: 0 12px 0 32px;
      .title {
        font-size: 27.34px;
        font-weight: bold;
        line-height: normal;
        color: #ffffff;
      }
      .publish-icon {
        display: none;
      }
      .nickname {
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        margin-top: 12px;
      }
      .tag {
        margin-top: 9px;
      }
    }
    .cover {
      .cover-img {
        width: 203px;
        height: 203px;
      }
    }
    .use-box {
      margin-top: 30px;
    }
    .audio-item-publish-btn {
      display: none;
    }
  }
}
</style>
